/**
 * @deprecated
 * use the file relationships.js, which is more organized and complete.
*/

export const relationshipIsRecess = (id) => ([ 4, 11, 15, 16 ]).includes(id)
